/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(theme => ({
  sidebar: {
    padding: '5% 1px 5% 5%',
    borderRight: '1px solid #959595',
    height: '100%',
    position: 'relative'
  },
  sidebarSurveyBody: {
    marginLeft: '40px',
    '& ul': {
      padding: 0
    },
    '& li': {
      margin: '7% 0',
      cursor: 'pointer',
      display: 'flex'
    }
  },
  sidebarName: {
    justifyContent: 'space-between',
    alignItems: 'center',
    '& span': {
      marginLeft: '10px'
    },
    '& img': {
      height: '18px',
      width: '18px'
    }
  },
  flex: {
    display: 'flex'
  },
  disable: {
    pointerEvents: 'none',
    opacity: 0.5,
    '&:hover': {
      cursor: 'not-allowed !important'
    }
  },
  selectedAssesment: {
    fontWeight: '500',
    opacity: '1'
  },
  iconChange: {
    '& img': {
      opacity: 0.5
    }
  }
}));

export default useStyles;
